<template>
  <div id="pass32">
    <v-card class="ep-rechner-box">
      <v-col cols="12" class="p-0">
        <div class="v-card__title p-0">
          <h2 class="v-card--head--title">{{ selectedLang.RejectionTile1 }}</h2>
        </div>
      </v-col>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <!-- <div class="v-card--msg">
              <h2 class="ep-rechner-h2" v-html="rejectionMessage"></h2>
            </div> -->
            <v-alert outlined color="error" transition="scale-transition" class="text-center"
              v-html="rejectionMessage"></v-alert>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-row>
          <v-col cols="12">
            <v-btn block class="btn-ep-next-step" @click="check32">{{ selectedLang.RejectionTile2 }}</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "RejectionTile",
  data: function () {
    return {};
  },
  computed: mapState(["selectedDiv", "rejectionMessage", "selectedLang"]),
  methods: {
    ...mapActions(["killRun"]),
    check32() {
      this.killRun({ vm: this });
    },
  },
};
</script>
